/** full data example 
 * 
 * https://maps.googleapis.com/maps/api/place/details/json?placeid=ChIJnyQUOfwEkWsRuiK5FJgO030&fields=name,rating,reviews&key=AIzaSyCjr87cGbPURVfGD6Dz87KYJIDXeMUigX8
 */


document.addEventListener('DOMContentLoaded', function(){

  var settings = {
        placeId: lsGoogleReviews.placeId
  };

  var reviewsContainer = document.getElementById('ls-google-reviews');
  var reviewsAgregateContainer = document.getElementById('ls-google-aggregate-reviews');

  // bail if page has no ls-google-revies container
  if(!reviewsContainer) return

  var service = new google.maps.places.PlacesService(document.createElement('div'));

  service.getDetails(settings, function(place, status) {
    if (status == google.maps.places.PlacesServiceStatus.OK) {
      lsGoogleReviews.renderReviews(place.reviews, reviewsContainer, 4);
      lsGoogleReviews.renderAgregateReviews(place, reviewsAgregateContainer);
    }
  });

  reviewsContainer.classList.add('md:grid', 'md:grid-cols-2', 'lg:grid-cols-4')


}, false);



window.lsGoogleReviews = {

  placeId: 'ChIJnyQUOfwEkWsRuiK5FJgO030',
  googleLink: 'https://www.google.com/search?q=localsearch+robina&rlz=1C5CHFA_enAU807AU807&oq=localsearch+rob&aqs=chrome.0.69i59j69i60l2j69i57j69i60j0.3524j0j4&sourceid=chrome&ie=UTF-8#lrd=0x6b9104fc3914249f:0x7dd30e9814b922ba,1,,,',

  /**
   * Render reviews HTML
   *
   * @param {array} reviews - array with google places
   * @param {HTML element} el - container to print reviews into
   * @return {string} A good string
   */
  renderReviews: function(reviews, el, qty){

    var template = '';
    var stars;
    var rating;

    for(var i = 0; i < qty; i++){

      var review = reviews[i];

      stars = this.getStarsIconsHTML(review.rating);

      template += 

      `<div class="bg-white ls-google-review flex-1 m-4 justify-between p-4 shadow rounded-md">
          <div class="ls-google-review-stars text-gold">${stars}</div>
          <p class="ls-google-review-excerpt line-clamp-6">${review.text}</p>
          <span class="ls-google-reviews-author mb-0 font-bold">${review.author_name}</span>
          <div class="ls-google-reviews-ago hidden">${review.relative_time_description}</div>
      </div>`;

    }

    el.innerHTML = template;

  },

  /**
   * Render agregate reviews HTML.
   *
   * @param {array} reviews - array with google places
   * @param {HTML element} el - container to print reviews into
   * @return {string} A good string
   */

  renderAgregateReviews : function(data, el){

    var stars = this.getStarsIconsHTML(data.rating);

    var template = `
      <div class="ls-google-aggregate-reviews-rating">
        ${data.rating}
        <span class="stars stars-google">${stars}</span>
      </div>
        ${data.user_ratings_total} reviews on <a href="${this.googleLink}">Google reviews</a>
    `;

     el.innerHTML = template;

  },


  /** 
   * Get rating as stars in HTML
   *
   * @param {int} rating the rating in 0 - 5 including decimal points
   *                     if rating is a fraction 0.2 or 0.6 half star will be used
   * @return {string} html with stars markup  
   */
  getStarsIconsHTML : function(rating){

      var stars = '';

      // add filled in stars
      for(var i = 0; i < Math.floor(rating); i++) {
        stars += '<i class="fa fa-star"></i>';
      }

      // add half star if decimal point
      if(rating % 1 != 0) stars += '<i class="fa fa-star-half-o"></i>'; 

      // add empty stars
      for(var i = 0; i < (5 - Math.ceil(rating)); i++) {
          stars += '<i class="fa fa-star-o"></i>'; 
      }

      return stars;
  }

}

